// Named imports only — a namespace import (`import * as Sentry`) references every
// export, which prevents webpack from tree-shaking out `lazyLoadIntegration`. That
// helper builds a `https://browser.sentry-cdn.com/.../*.min.js` URL and loads it at
// runtime, which Chrome Web Store flags as remotely-hosted code (MV3 rejection
// "Blue Argon"). Importing only what we use lets the CDN loader drop from the bundle.
import { init, browserTracingIntegration, captureException } from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;

export function initSentry(): void {
  if (!dsn) return; // no-op in dev unless DSN is configured

  init({
    dsn,
    environment: process.env.NODE_ENV,
    // CI injects REACT_APP_VERSION as the git SHA so source maps line up with the release
    release: process.env.REACT_APP_VERSION || 'dev',
    // Capture 100% of errors; sample traces at 10% to keep quotas low
    tracesSampleRate: 0.1,
    // Only send errors — not console noise
    integrations: [browserTracingIntegration()],
    // Strip PII from breadcrumbs
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
        // Don't log request bodies
        if (breadcrumb.data) {
          delete breadcrumb.data.body;
        }
      }
      return breadcrumb;
    },
  });
}

// Re-export a minimal surface so callers keep using `Sentry.captureException(...)`
// without a namespace import pulling the whole SDK (and the CDN loader) back in.
export const Sentry = { captureException };
